import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentHeader: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.Policy Change - Farm',
        defaultMessage: 'Policy Change - Farm'
    },
    farmPolicyChangeCoverages: {
        id: 'endorsement.farm.directives.templates.farm-coverages.Coverages',
        defaultMessage: 'Coverages'
    },
    farmPolicyChangeAddress: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Address',
        defaultMessage: 'Address'
    },
    farmPolicyChangeItemDetails: {
        id: 'endorsement.farm.directives.templates.farm-mortgagee.ItemDetails',
        defaultMessage: 'Item Details'
    },
    farmPolicyChangeItemInfo: {
        id: 'endorsement.farm.directives.templates.farm-mortgagee.ItemInfo',
        defaultMessage: 'Item Info'
    },
    farmPolicyChangeRiskAnalysis: {
        id: 'endorsement.farm.directives.templates.farm-mortgagee.RiskAnalysis',
        defaultMessage: 'Risk Analysis'
    },
    farmPolicyChange: {
        id: 'endorsement.farm.directives.templates.farm-policy-changes.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    farmPolicyChangeQuotes: {
        id: 'endorsement.farm.views.history.Quote',
        defaultMessage: 'Quote'
    },
    farmPolicyChangePayments: {
        id: 'endorsement.farm.directives.templates.farm-coverages.Payments',
        defaultMessage: 'Payments'
    },
    anErrorOccurred: {
        id: 'gw-portals-policytransaction-pc-farm.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-pc-farm.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-pc-farm.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-pc-farm.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    farmPolicyDetails: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Policy Details',
        defaultMessage: 'Policy Details'
    },
    farmPolicyChange: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Download Upload Template',
        defaultMessage: 'Download/Upload Template'
    },
    farmPolicyChange: {
        id: 'endorsement.farm.directives.templates.farm-valuables.Farmer Details',
        defaultMessage: 'Farmer Details'
    },
});
